"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUndefined = exports.isDefined = exports.isInputEvent = exports.__TEST__ = exports.__DEV__ = exports.isString = exports.isNull = exports.isNotEmptyObject = exports.isEmptyObject = exports.isObject = exports.isFunction = exports.isEmptyArray = exports.isArray = exports.isNumeric = exports.isNotNumber = exports.isNumber = void 0;
// Number assertions
function isNumber(value) {
    return typeof value === 'number';
}
exports.isNumber = isNumber;
function isNotNumber(value) {
    return typeof value !== 'number' || Number.isNaN(value) || !Number.isFinite(value);
}
exports.isNotNumber = isNotNumber;
function isNumeric(value) {
    return value != null && value - parseFloat(value) + 1 >= 0;
}
exports.isNumeric = isNumeric;
// Array assertions
function isArray(value) {
    return Array.isArray(value);
}
exports.isArray = isArray;
function isEmptyArray(value) {
    return isArray(value) && value.length === 0;
}
exports.isEmptyArray = isEmptyArray;
// Function assertions
function isFunction(value) {
    return typeof value === 'function';
}
exports.isFunction = isFunction;
// Object assertions
function isObject(value) {
    const type = typeof value;
    return value != null && (type === 'object' || type === 'function') && !isArray(value);
}
exports.isObject = isObject;
function isEmptyObject(value) {
    return isObject(value) && Object.keys(value).length === 0;
}
exports.isEmptyObject = isEmptyObject;
function isNotEmptyObject(value) {
    return value && !isEmptyObject(value);
}
exports.isNotEmptyObject = isNotEmptyObject;
function isNull(value) {
    return value == null;
}
exports.isNull = isNull;
// String assertions
function isString(value) {
    return Object.prototype.toString.call(value) === '[object String]';
}
exports.isString = isString;
exports.__DEV__ = process.env.NODE_ENV !== 'production';
exports.__TEST__ = process.env.NODE_ENV === 'test';
function isInputEvent(value) {
    return value && isObject(value) && isObject(value.target);
}
exports.isInputEvent = isInputEvent;
// Generic assertions
function isDefined(value) {
    return typeof value !== 'undefined' && value !== undefined;
}
exports.isDefined = isDefined;
function isUndefined(value) {
    return typeof value === 'undefined' || value === undefined;
}
exports.isUndefined = isUndefined;
//# sourceMappingURL=assertion.js.map